import { toast } from 'react-toastify';
import { isPossibleNumber } from 'libphonenumber-js';
import moment from 'moment';
import { set } from 'lodash';
import { logoutSuccess } from '../admin/store/features/authSlice';

let isErrorToastShown = false;
const TOAST_COOLDOWN = 3000; // prevent duplicate alerts within 3s

// Common Date Fromat
const dateFormatCommon = () => {
  return 'dd-MM-yyyy';
};
// Date Format Add Manually
const dateFormatManualAdd = (e) => {
  if (!/[0-9]/.test(e.key) && e.key === 'Backspace') {
    return false;
  } else {
    e.currentTarget.value = e.currentTarget.value.replace('-', '');
    if (e.currentTarget.value.length > 8) {
      e.preventDefault();
    }
    var numbers = e.currentTarget.value.replace(/[^0-9]/, ''),
      char = { 2: '-', 4: '-' };
    e.currentTarget.value = '';
    for (var i = 0; i < numbers.length; i++) {
      e.currentTarget.value += (char[i] || '') + numbers[i];
    }
    return e.currentTarget.value;
  }
};

// Default Value From Array And Selected Value
const defaultValue = (option, value) => {
  // return option ? option.find((option) => option.value == value) : '';
  if (!option) return '';

  if (Array.isArray(value)) {
    return option.filter((op) => value.includes(op.value));
  } else {
    return option.find((op) => op.value == value) || '';
  }
};

// Default Error Handler
const onDefaultError = (error,showAlert = true) => {
    if (isErrorToastShown) return;
    isErrorToastShown = true;
    setTimeout(() => (isErrorToastShown = false), TOAST_COOLDOWN);

    toast.dismiss();
  if (error?.logged_out || error?.data?.logged_out) {
        dispatchAction(logoutSuccess());
        cnavigate('/login');
        window.addEventListener('storage', (e) => {
            e.isLogout = 1;
        });
        const body = document.body;
        body.className = '';
        body.classList.add('bg-box');
        toast.error(error.message);
  } else if (error?.redirect || error?.data?.redirect) {
    toast.error(error.message);
    cnavigate('/dashboard');
  } else if(showAlert) {
    toast.error(error.message);
  }
};
// Phone Number Validation
const phoneNumberValidation = async (countryCode, phoneCode, phoneNumberValue) => {
  return new Promise(function (accepted, rejected) {
    let isValidRequest = phoneNumberValue ? false : true;
    const phoneNumber = '+' + phoneCode + '-' + phoneNumberValue;
    if (phoneNumber) {
      const isValid = isPossibleNumber(phoneNumber, countryCode?.toString());
      if (isValid) {
        isValidRequest = true;
      }
      accepted(isValidRequest);
    }
  });
};

const isMobileOrTablet = () => {
  return window.innerWidth <= 992;
};

// The formatTimeSpent function converts a decimal value of hours (e.g., 2.5) into a human-readable format (e.g., "2h 30m"), enhancing clarity for time tracking and management applications.
function formatTimeSpent(timeSpent) {
  // Convert the input to a number
  const totalHours = parseFloat(timeSpent);

  // Get whole hours and remaining minutes
  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);

  // Create the formatted string
  const parts = [];
  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }

  return parts.join(' ');
}

function formatTimeSpentForTaskView(timeSpent, type = 'half') {
  let totalHours = parseFloat(timeSpent);

  const isNegative = totalHours < 0;
  totalHours = Math.abs(totalHours);

  // Get whole hours and remaining minutes
  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);

  // Create the formatted string
  const parts = [];
  if (hours > 0) {
    if (type === 'full') {
      parts.push(`${hours} hours`);
    } else {
      parts.push(`${hours}h`);
    }
  }
  if (minutes > 0) {
    if (type === 'full') {
      parts.push(`${minutes} minutes`);
    } else {
      parts.push(`${minutes}m`);
    }
  }

  if (hours === 0 && minutes === 0) {
    return type === 'full' ? '0 minutes' : '0m';
  }

  const result = parts.join(' ');
  return isNegative ? `- ${result}` : result;
}

function convertTimeInHoursAndMinutes(h, min) {
  var h = Number(h);
  var min = Number(min);
  // Convert minutes to hours if minutes are 60 or more
  let extraHours = Math.floor(min / 60);
  min = min % 60;

  // Add the extra hours to the given hours
  h += extraHours;

  // Return the formatted string
  var returntime = h != '' && h > 0 ? `${h}h` : '';
  returntime += min != '' && min > 0 ? ` ${min}m` : '';

  return returntime;
}
/**
 * Converts given minutes to percentage of an hour (60 minutes).
 * @param {number} minutes - The number of minutes to convert.
 * @returns {number} Percentage (rounded to 2 decimal places)
 */
function convertMinutesToPercentage(minutes) {
  const totalMinutes = 60;
  if (!_.isNumber(minutes) || minutes < 0) {
    return 0;
  }

  const percentage = (minutes / totalMinutes);
  return _.round(percentage, 2);
}
function getTotalDays(startDate, endDate) {
  // Parse the dates
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Calculate the difference in milliseconds
  const differenceInTime = end - start;

  // Calculate the difference in days
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  console.log('differenceInDays:', differenceInDays);
  return differenceInDays;
}

function getWeekStartAndEnd(date) {
  const startDate = new Date(date);
  const endDate = new Date(date);

  // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const dayOfWeek = startDate.getDay();

  // Calculate the start date (Monday of the current week)
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  startDate.setDate(startDate.getDate() + mondayOffset);

  // Calculate the end date (Sunday of the current week)
  const sundayOffset = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
  endDate.setDate(endDate.getDate() + sundayOffset);

  // Set time to the start of the day
  startDate.setHours(0, 0, 0, 0);
  // Set time to the end of the day
  endDate.setHours(23, 59, 59, 999);

  return {
    start: moment(startDate).format('YYYY-MM-DD'),
    end: moment(endDate).format('YYYY-MM-DD')
  };
}

function getStoredData(storageKey, property, defaultValue) {
  const stored = localStorage.getItem(storageKey);
  if (stored && stored !== '') {
    try {
      const parsed = JSON.parse(stored);
      return parsed?.[property] ?? defaultValue;
    } catch (e) {
      console.error('Error parsing localStorage:', e);
    }
  }
  return defaultValue;
}

function calculateTimeProgress(estimateTime, timeTaken) {
  console.log('estimateTime:', estimateTime);
  console.log('timeTaken:', timeTaken);
  const estimateInMinutes = estimateTime * 60;
  const takenInMinutes = timeTaken * 60;
  console.log('estimateInMinutes:', estimateInMinutes);
  console.log('takenInMinutes:', takenInMinutes);
  let percentage = (takenInMinutes / estimateInMinutes) * 100;

  const time_taken_is_more_than_estimate_time = takenInMinutes > estimateInMinutes;

  // Cap percentage at 100% for UI progress bars
  if (percentage > 100) {
    percentage = 100;
  }

  let remaining_time = estimateInMinutes - takenInMinutes; // can be negative
  console.log('remaining_time:', remaining_time);
  if (remaining_time < 0) {
    remaining_time = 0;
  }
  return {
    time_progress_percentage: Math.round(percentage),
    time_taken_is_more_than_estimate_time,
    remaining_time: remaining_time > 0 ? formatRemainingTime(remaining_time) : 0 // in minutes (can be negative)
  };
}

function formatRemainingTime(minutes) {
  const hrs = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  if (hrs > 0) {
    if (mins > 0) {
      return `${hrs}h ${mins}m`;
    }
    return `${hrs}h`;
  }
  return `${mins}m`;
}
const getPlainTextFromQuill = (value) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = value || '';
  return tempDiv.textContent || tempDiv.innerText || '';
};

// Helper: map history_type to readable action
function getHistoryActionText(historyType, type, afterChange, before_change, t) {
    const map = {
        1: t('page.activity_change_status_label'),
        2: t('page.activity_change_assignee_label'),
        3: t('page.activity_change_sprint_label'),
        4: t('page.activity_change_estimation_label'),
        5: t('page.activity_change_priority_label'),
        6: (() => {
            if (type === 1) {
                return t('page.activity_add_create_task_label');
            }
            if (type === 2) {
                return t('page.activity_update_taskname_label');
            }
            if (type === 3) {
                return t('page.activity_deleted_task_label');
            }
            return t('page.activity_update_taskname_label')
        })(),
        7: t('page.activity_update_description_label'),
        8: (() => {
            if (type === 3) {
                return <>{t('page.activity_deleted_label')} <span className='bold'>{before_change}</span> {t('page.activity_worklog_label')}</>;
            }
            if (type === 2) {
                return <>{t('page.activity_worklog_updated_label')}</>;
            }
            return <>{t('page.activity_logged_label')} <span className='bold'>{afterChange}</span></>;
        })()
    };
    return map[historyType] || <>{t('page.activity_updated_label')} <span>{afterChange}</span></>;
}

// Helper: format "time ago"
function formatTimeAgo(dateTime, t) {
    const diff = (new Date() - new Date(dateTime)) / 1000; // seconds

    if (diff < 60) {
        return t('page.activity_just_now_label'); // e.g., "Just now"
    }

    const minutes = Math.floor(diff / 60);
    const hours = Math.floor(minutes / 60);

    if (minutes < 60) {
        return `${minutes} ${t('page.activity_min_ago_label')}`; // e.g., "5 mins ago"
    }

    if (hours < 24) {
        const remainingMinutes = minutes % 60;
        if (remainingMinutes > 0) {
            return `${hours}h ${remainingMinutes}m ${t('page.activity_ago_label')}`;
            // e.g., "2h 15m ago"
        }
        return `${hours}h ${t('page.activity_ago_label')}`;
        // e.g., "3h ago"
    }

    // For older than a day → show time (AM/PM)
    const date = new Date(dateTime);
    return date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
}

const setPageMoveToFirstPage = (setCurrentPage, name) => {
  setCurrentPage(1);
  const getData = localStorage.getItem(name);
  if (getData && getData !== '') {
    const parsedData = JSON.parse(getData);
    parsedData.currentPage = 1;
    localStorage.setItem(name, JSON.stringify(parsedData));
  }
};

let navigateFn;
let dispatchFn;

const setNavigator = (navFn) => {
    navigateFn = navFn;
};

const cnavigate = (path) => {
    if (navigateFn){
        navigateFn(path);
    }
};


const setDispatcher = (dispatch) => {
  dispatchFn = dispatch;
};

const dispatchAction = (action) => {
  if (dispatchFn) dispatchFn(action);
};




export {
  defaultValue,
  dateFormatCommon,
  dateFormatManualAdd,
  onDefaultError,
  phoneNumberValidation,
  isMobileOrTablet,
  formatTimeSpent,
  formatTimeSpentForTaskView,
  convertTimeInHoursAndMinutes,
  getTotalDays,
  getWeekStartAndEnd,
  getStoredData,
  calculateTimeProgress,
  convertMinutesToPercentage,
  getPlainTextFromQuill,
  getHistoryActionText,
  formatTimeAgo,
  setPageMoveToFirstPage,
    setNavigator,
    cnavigate,
    setDispatcher,
    dispatchAction

};
